import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/system-users/SystemUsersAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { SystemUserEditForm } from "./SystemUserEditForm";

export function SystemUserEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, systemUser } = useSelector(
    (state) => ({
      actionsLoading: state.systemUsers.actionsLoading,
      isSuccess: state.systemUsers.isSuccess,
      type: state.systemUsers.type,
      systemUser: state.systemUsers.systemUser,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getSystemUser(id));
    return () => dispatch(actions.cleanSystemUsersState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Kullanıcı";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  const saveSystemUser = (values) => {
    dispatch(actions.saveSystemUser(values)).then((result) => onResult(result));
  };
  
  const btnRef = useRef();  
  const saveSystemUserClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/kullanicilar`), 2500)
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <SystemUserEditForm 
            systemUser={systemUser}
            btnRef={btnRef} 
            saveSystemUser={saveSystemUser}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveSystemUserClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}